import React from "react";
import {
  AdjustmentsHorizontalIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { Link, useNavigate } from "@remix-run/react";
import { classNames } from "~/utils";

// import Button from "./tw_button";
import theme from "~/theme/default";
interface ISearchBox {
  setSearchQuery: (value: string) => void;
  query?: string;
  defaultValue?: string;
  isLandingPage?: boolean;
  formAction: string;
  placeHolder?: string;
  onSubmit?: () => void;
  activeTab?: "medien" | "fachartikel" | "veranstaltungen";
}
const SearchBox: React.FC<ISearchBox> = ({
  isLandingPage = false,
  formAction,
  query,
  onSubmit,
  setSearchQuery,
  activeTab = "medien",
}) => {
  const { button } = theme;
  const { base } = button;
  const navigate = useNavigate();

  // Determine the Lehrplanfilter link based on active tab
  const getLehrplanfilterLink = () => {
    if (activeTab === "fachartikel") {
      return "/professional_article/main?openmoldal=1";
    }
    return "/search/main?openmoldal=1";
  };

  const handleKeyup = () => {
    navigate(formAction);
    if (typeof onSubmit === "function") {
      onSubmit();
    }
  };
  return (
    <div className="flex w-full lg:justify-center lg:align-middle">
      <div
        className={classNames(
          isLandingPage ? "justify-center" : "justify-start ",
          "relative flex w-full items-center lg:justify-between"
        )}
      >
        <div
          className={classNames(
            "min-w-0 flex-1 md:px-8 lg:px-0 xl:col-span-6"
            // isLandingPage ? "hidden" : "block"
          )}
        >
          <div className="flex items-center py-4 md:mx-auto md:max-w-3xl lg:mx-0 lg:max-w-none xl:px-0">
            <div className="w-full">
              {/* <label htmlFor="q" className="sr-only">
                Search
              </label> */}
              <div className="relative">
                <div className="pointer-events-none absolute inset-y-0 left-0 hidden items-center  pl-3 md:flex">
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-black"
                    aria-hidden="true"
                  />
                </div>
                <input
                  // type="text"
                  value={query}
                  // search.changeSearchTerm(e.currentTarget.value)
                  onChange={(e: any) => setSearchQuery(e.currentTarget.value)}
                  //handleSearch(e)
                  // onKeyPress={(e: any) => null}
                  // id="search"
                  // defaultValue={defaultValue}
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      handleKeyup();
                    }
                  }}
                  name="q"
                  className={classNames(
                    isLandingPage ? "bg-[#F6F6F6]" : "bg-white",
                    `block w-full rounded-full py-3
                  pl-10 pr-3 text-sm placeholder-gray-500 shadow-[0_1px_3px_rgba(0,0,0,0.134479)] focus:border-btnColor-secondary focus:text-gray-900 focus:placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-btnColor-secondary sm:text-sm`
                  )}
                  placeholder={
                    isLandingPage
                      ? activeTab === "fachartikel"
                        ? "Finde deinen Fachbeitrag"
                        : activeTab === "medien"
                        ? "Finde dein Medium"
                        : "Finde ..."
                      : "Suche ..."
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {/* MOBILE Btn START PAGE */}
        <div className="ml-1 flex-col md:hidden">
          <button
            type="button"
            onClick={() => {
              navigate(formAction);
              if (typeof onSubmit === "function") {
                onSubmit();
              }
            }}
            className={classNames(
              // open ? "text-gray-900" : "text-gray-500",
              base,
              // navBar,
              "group rounded-full bg-btnColor-secondary px-2.5 text-xs font-normal text-white"
            )}
          >
            {" "}
            <MagnifyingGlassIcon
              className={classNames(
                // open ? "text-gray-600" : "text-textColor-light",
                "h-6 w-6 text-white"
              )}
              aria-hidden="true"
            />
            {/* <span>Lernplanfilters</span> */}
          </button>
        </div>
        {/* END MOBILE Btn START PAGE */}
        <div className="ml-3 hidden md:flex">
          {isLandingPage && (
            <Link to={getLehrplanfilterLink()}>
              <button
                type="button"
                className={classNames(
                  "inline-flex items-center rounded-full bg-[#F6F6F6] px-6 py-2 text-xs font-medium text-gray-500 hover:bg-btnColor-hoverPrimary hover:text-white md:text-sm",
                  base
                )}
              >
                <AdjustmentsHorizontalIcon
                  className="mr-2 h-4 w-4"
                  aria-hidden="true"
                />
                <span>Lehrplanfilter</span>
              </button>
            </Link>
          )}
          <button
            onClick={() => {
              navigate(formAction);
              if (typeof onSubmit === "function") {
                onSubmit();
              }
            }}
            type="button"
            className="ml-3 inline-flex items-center rounded-full border border-transparent bg-btnColor-secondary px-6 py-2 text-xs font-medium text-white shadow-sm hover:bg-btnColor-hoveSecondary focus:outline-none focus:ring-2 focus:ring-btnColor-secondary focus:ring-offset-2 md:px-8 md:text-sm"
          >
            {isLandingPage
              ? activeTab === "fachartikel"
                ? "Fachbeitrag finden"
                : "Medien finden"
              : "Suchen"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBox;
